<template>
    <section class="c-cart-checkout__section">
        <div class="o-color-change" data-logo-colors="logo-icon-is-color-1-darker, logo-text-is-color-1-darker"></div>
        <div class="o-grid">
            <div class="o-grid-8 -y-0" id="billing">
                <div class="c-cart__checkout">
                    <div class="o-form__wrap">
                        <h2 class="c-cart-checkout__title">Facturation</h2>
                        <form class="o-form" method="post" autocomplete="off" @change="updateCart">
                            <div v-if="confirm.message" class="o-form__confirmation"
                                :class="{ '-error': confirm.state == 'error', '-success': confirm.state == 'success' }">
                                <p class="o-form__confirmation__text">{{ confirm.message }}</p>
                            </div>
                            <div class="o-form__row">
                                <div class="o-form__group">
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.first_name }" type="text" id="prenom" name="Prénom" 
                                        v-model="cart.billing_address.first_name" required @change="updateCart">
                                        <label class="o-label" for="prenom">Prénom</label>
                                </div>

                                <div class="o-form__group">
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.last_name }" type="text" id="nom" name="Nom"
                                        v-model="cart.billing_address.last_name" required @change="updateCart">
                                        <label class="o-label" for="nom">Nom</label>
                                </div>

                                <div class="o-form__group">
                                    <label class="o-label sr-only" for="telephone">Téléphone</label>
                                    <MazPhoneNumberInput v-model="cart.billing_address.phone" color="info"
                                        :onlyCountries="['CA']" :success="results?.isValid" noSearch="true"
                                        :noCountrySelector="true"
                                        :translations="{
                                            countrySelector: {
                                                placeholder: 'Code de pays',
                                                error: 'Choisissez un pays',
                                            },
                                            phoneInput: {
                                                placeholder: 'Numéro de téléphone',
                                                example: 'Exemple:',
                                            },
                                        }" @change="updateCart" />
                                </div>

                                <div class="o-form__group">
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.email }" type="email" id="courriel" name="Courriel"
                                            v-model="cart.billing_address.email" required
                                        @change="updateCart">
                                    <label class="o-label" for="courriel">Courriel</label>
                                </div>

                                <div class="o-form__group">
                                    <GMapAutocomplete autocomplete="stereostore-add" name="stereostore-add" class="o-input"
                                        :placeholder="''"
                                        :class="{'-input-filled' : cart.billing_address.address_1 }"
                                        :value="cart.billing_address.address_1" @place_changed="setPlace"
                                        @change="cart.billing_address.address_1 = $event.target.value"
                                        @click="updateAutoComplete"
                                        id="stereostore-add">
                                    </GMapAutocomplete>
                                    <label class="o-label" for="stereostore-add">Adresse postale</label>
                                </div>

                                <div class="o-form__group">
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.address_2 }" type="text" id="address_2" name="Ville"
                                            v-model="cart.billing_address.address_2"
                                        @change="updateCart">
                                    <label class="o-label" for="address_2">Complément d'adresse</label>
                                </div>

                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="ville" name="Ville" 
                                        :class="{'-input-filled' : cart.billing_address.city }"
                                        v-model="cart.billing_address.city" required @change="updateCart">
                                        <label class="o-label" for="ville">Ville</label>
                                    </div>

                                    <div class="o-form__group">
                                    <div class="o-select__wrap">
                                        <select class="o-select" id="pays" name="Pays"
                                            v-model="cart.billing_address.country" required @change="updateCart">
                                            <option value="" disabled selected>Pays</option>
                                            <option value="Canada">Canada</option>
                                            <option value="United States">États-Unis</option>
                                        </select>
                                    </div>
                                    <label class="o-label sr-only" for="pays">Pays</label>
                                </div>

                                <div class="o-form__group">
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.state }" type="text" id="province" name="Province"
                                            v-model="cart.billing_address.state" required
                                        @change="updateCart">
                                    <label class="o-label" for="province">Province</label>
                                </div>

                                <div class="o-form__group">
                                    <input class="o-input" :class="{'-input-filled' : cart.billing_address.postcode }" type="text" id="code_postal" name="Code postal"
                                            v-model="cart.billing_address.postcode" required
                                        @change="updateCart">
                                    <label class="o-label" for="code_postal">Code postal</label>
                                </div>
                            </div>
                        </form>
                        <div v-if="cart.discounts" class="c-cart-checkout__discounts">
                            <div v-for="discount in cart.discounts" :key="discount.id" class="c-cart-checkout__discounts__item">
                                <p>{{ discount.name }}</p>
                                <p class="c-cart-checkout__amount">{{ formatMoney(discount.amount) }}</p>
                                <span @click="removeDiscount(discount.id, $event)">Supprimer</span>
                            </div>
                        </div>
                        <div class="o-button__container c-cart-checkout__btn">
                            <div v-if="!isEmpty(cart.items) && addingDiscount == false  && showDiscounts" class="o-form__button">
                                <button class="o-button  o-button-cart" type="button" @click="addingDiscount = true">
                                    <span class="o-button__text">Ajouter une remise</span>
                                    <span class="sr-only">Ajouter une remise</span>
                                    <svg class="o-ico -icon-arrow-full-right" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z" />
                                    </svg>
                                </button>
                            </div>

                            <form class="o-form" @submit.prevent="addDiscount()" v-if="!isEmpty(cart.items) && addingDiscount == true">
                                <div class="o-form__group">
                                    <input class="o-input" :class="{'-input-filled' : discountCode }" type="text" id="discount" name="Code de remise"
                                        v-model="discountCode" required>
                                    <label class="o-label" for="discount">Code de remise</label>
                                </div>
                                <div class="o-form__button o-button__container">
                                    <button class="o-button  o-button-cart" type="submit">
                                        <span class="o-button__text">Ajouter</span>
                                        <span class="sr-only">Ajouter</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="o-ico -icon-arrow-full-right">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </button>
                                    <button class="o-button  o-button-cart" type="button" @click="addingDiscount = false">
                                        <span class="o-button__text">Annuler</span>
                                        <span class="sr-only">Annuler</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="o-ico -icon-arrow-full-right">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="o-grid-4 -y-0" :class="{ 'is-loading': loadingSummarize }" id="billing-resume">
                <h2 class="c-cart-checkout__title -spacer-mobile">
                    Votre commande
                </h2>
                <!--Product lists with price-->
                <div class="c-cart__checkout">
                    <div v-if="!isEmpty(cart.items)" class="o-form__wrap">
                        <div class="o-grid" v-for="item in cart.items" :key="item.product_id">
                            <div v-if="item.type != 'cdj'" class="o-grid-6">
                                <p class="c-cart-checkout__label">{{ item.name }} x{{ item.quantity }}</p>
                                <p class="c-cart-checkout__description" v-if="item.description">{{ item.description }}</p>
                            </div>
                            <div v-else class="o-grid-6">
                                <p class="c-cart-checkout__label">{{ item.name }}</p>
                                <p class="c-cart-checkout__description" v-if="item.description">{{ item.metadata.first_name }} {{ item.metadata.last_name }}</p>
                            </div>
                            <div class="o-grid-6">
                                <p class="c-cart-checkout__amount">{{ formatMoney(item.total) }}</p>
                            </div>
                        </div>
                        <hr>
                        <div v-if="showDiscounts && cart.discountTotal" class="o-grid">
                            <div class="o-grid-6">
                                <p class="c-cart-checkout__label">Remise</p>
                            </div>
                            <div class="o-grid-6">
                                <p class="c-cart-checkout__amount">{{ formatMoney(cart.discountTotal) }}</p>
                            </div>
                        </div>
                        <div class="o-grid">
                            <div class="o-grid-6">
                                <p class="c-cart-checkout__label">Sous-total</p>
                            </div>
                            <div class="o-grid-6">
                                <p class="c-cart-checkout__amount">{{ formatMoney(cart.subtotal) }}</p>
                            </div>
                        </div>
                        <div v-if="showTaxes" class="o-grid">
                            <div class="o-grid-6">
                                <p class="c-cart-checkout__label">Taxes</p>
                            </div>
                            <div class="o-grid-6" v-if="cart.billing_address.country != ''">
                                <p class="c-cart-checkout__taxes">{{ calculateTaxes() }}</p>
                            </div>
                            <div class="o-grid-6" v-else>
                                <p class="c-cart-checkout__taxes">Entrer votre adresse pour calculer les taxes</p>
                            </div>
                        </div>
                        <div class="o-grid">
                            <div class="o-grid-6">
                                <p class="c-cart-checkout__label">Total</p>
                            </div>
                            <div class="o-grid-6">
                                <p class="c-cart-checkout__amount">{{ formatMoney(cart.total) }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="c-cart__checkout">
                            <div class="o-form__wrap">
                                <p>Votre panier est vide.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="o-button__container c-cart-checkout__btn">

                    <div v-if="!isEmpty(cart.items)" class="">
                        <button @click="checkoutSubmit" class="o-button  o-button-cart" type="submit" :class="{ loadingCheckout: 'is-loading' }"
                            :disabled="loadingCheckout">
                            <span class="o-button__text">Passer au paiement</span>
                            <span class="sr-only">Passer au paiement</span>
                            <svg v-if="!loadingCheckout" aria-hidden="true" focusable="false" class="o-ico -icon-arrow-full-right">
                                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#pay"></use>
                            </svg> 
                            <svg v-else aria-hidden="true" focusable="false" class="o-ico -icon-spinner">
                                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#spinner"></use>
                            </svg>
                        </button>
                    </div>

                    <button class="o-button" @click="modify()">
                        <span class="o-button__text">Modifier mon panier</span>
                        <span class="sr-only">Modifier mon panier</span>
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'

export default {
    name: 'ProductCart',
    data() {
        return {
            cart: {
                billing_address: {}
            },
            token: null,
            loadingSummarize: false,
            loadingCheckout: false,
            confirm: {
                message: '',
                state: ''
            },
            addingDiscount: false,
            discountCode: '',
            showDiscounts: window.ajax_var.showDiscounts,
            showTaxes: window.ajax_var.showTaxes
        }
    },
    components: {
        MazPhoneNumberInput,
    },
    methods: {
        async getCart() {
            this.loadingSummarize = true
            if (!this.$store.state.token) {
                //Redirect to home page
                location.href = '/'
            }
            this.token = this.$store.state.token

            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                rand : Math.random()
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            await axios.get('/wp-json/stereostore/v1/cart', { params })
                .then(response => {
                    response.data.data.items.forEach(item => {
                        if (item.type == 'cjd') {
                            item.metadata = JSON.parse(item.metadata)
                        }
                    });
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    this.loadingSummarize = false
                })
                .catch(error => {
                    console.log(error)
                })

            return this.cart
        },
        formatMoney(value) {
            let language = 'fr';
            let currency = 'CAD';
            var formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });
            return formatter.format(value);
        },
        calculateTaxes() {
            let taxes = this.cart.taxes
            let total = 0
            for (let i = 0; i < taxes.length; i++) {
                total += taxes[i].amount
            }
            return this.formatMoney(total)
        },
        checkout() {
            location.href = '/caisse/'
        },
        modify() {
            location.href = '/panier/'
        },
        isEmpty(array) {
            return !Array.isArray(array) || !array.length
        },
        setPlace(place) {
            //foreach place.address_components
            place.address_components.forEach(item => {
                if (item.types[0] == 'street_number') {
                    this.cart.billing_address.address_1 = item.long_name
                }
                if (item.types[0] == 'route') {
                    this.cart.billing_address.address_1 += ' ' + item.long_name
                }
                if (item.types[0] == 'locality') {
                    this.cart.billing_address.city = item.long_name
                }
                if (item.types[0] == 'administrative_area_level_1') {
                    this.cart.billing_address.state = item.long_name
                }
                if (item.types[0] == 'country') {
                    this.cart.billing_address.country = item.long_name
                }
                if (item.types[0] == 'postal_code') {
                    this.cart.billing_address.postcode = item.long_name
                }
            });

            this.cart.billing_address.fullAddress = place
            this.updateCart()
        },
        updateCart() {
            this.loadingSummarize = true
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                cart: this.cart
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.put('/wp-json/stereostore/v1/cart', params)
                .then(response => {
                    this.loadingSummarize = false
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    document.getElementById('stereostore-add').setAttribute('autocomplete', 'new-password')
                })
                .catch(error => {
                    console.log(error)
                })
        },
        updateAutoComplete() {
            //Set timeout to avoid conflict with google maps autocomplete
            setTimeout(() => {
                document.getElementById('stereostore-add').setAttribute('autocomplete', 'new-password')
            }, 1000)
        },
        checkoutSubmit() {
            this.loadingCheckout = true
            if(this.validateForm() == false) {
                this.loadingCheckout = false
                return
            }
            //Check if cart is empty
            if (this.isEmpty(this.cart.items)) {
                alert('Votre panier est vide.')
                this.loadingCheckout = false
                return
            }

            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                rand : Math.floor(Math.random() * 1000000)
            }

            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.get('/wp-json/stereostore/v1/cart/checkout', { params })
                .then(response => {
                    this.confirm = {
                        state: 'success',
                        message: response.data.message
                    }
                    //Redirect to payment gateway
                    location.href = response.data.data.url

                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                    this.loadingCheckout = false
                })

        },
        validateForm(){
            let valid = true
            let error = ''
            if(this.cart.billing_address.first_name == '') {
                error = 'Veuillez entrer votre prénom'
                valid = false
            }
            if(this.cart.billing_address.last_name == '') {
                error = 'Veuillez entrer votre nom'
                valid = false
            }
            if(this.cart.billing_address.phone == '') {
                error = 'Veuillez entrer votre numéro de téléphone'
                valid = false
            }
            if(this.cart.billing_address.email == '') {
                error = 'Veuillez entrer votre courriel'
                valid = false
            }
            if(this.cart.billing_address.address_1 == '') {
                error = 'Veuillez entrer votre adresse'
                valid = false
            }
            if(this.cart.billing_address.city == '') {
                error = 'Veuillez entrer votre ville'
                valid = false
            }
            if(this.cart.billing_address.state == '') {
                error = 'Veuillez entrer votre province'
                valid = false
            }
            if(this.cart.billing_address.postcode == '') {
                error = 'Veuillez entrer votre code postal'
                valid = false
            }
            if(!valid) {
                this.confirm = {
                    state: 'error',
                    message: error
                }
            }

            return valid
        },
        addDiscount() {
            this.confirm = {
                message: '',
                state: ''
            };
            this.loadingSummarize = true
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                code: this.discountCode
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.post('/wp-json/stereostore/v1/cart/discount', params)
                .then(response => {
                    this.loadingSummarize = false
                    this.cart = response.data.data
                    this.token = response.data.data.token
                    this.addingDiscount = false
                    this.discountCode = ''
                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                    this.loadingSummarize = false
                })
        },
        removeDiscount(id, event){
            this.confirm = {
                message: '',
                state: ''
            };
            event.preventDefault()
            this.loadingSummarize = true
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce,
                id: id
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.delete('/wp-json/stereostore/v1/cart/discount', { params })
                .then(response => {
                    this.loadingSummarize = false
                    this.cart = response.data.data
                    this.token = response.data.data.token
                })
                .catch(error => {
                    this.confirm = {
                        state: 'error',
                        message: error.response.data.message
                    }
                    this.loadingSummarize = false
                })
        }
    },
    mounted() {
        this.getCart();
        document.body.className.split(' ').forEach(function (className) {
            if (className.match(/^u-/)) {
                document.body.classList.remove(className);
            }
        });
        document.body.classList.add('u-bg-color-1', 'u-color-1-darker', 't-cart')
        document.querySelector('.c-footer__inner').classList.add('u-bg-color-3-darker', 'u-color-3-light')
        document.querySelector('.c-footer').style.display = 'none'
        this.updateAutoComplete()
    },
}
</script>